import { useTranslation } from 'react-i18next';

import { Button, Card, ExternalLinkButton, StatusTag, Text, Title } from '~/components';

import { actionsStyle, contentStyle, discountStyle, headerStyle, logoStyle, systemStyle } from './ExternalSystems.css';

type Props = {
  disabled?: boolean;
  imageUrl: string;
  isPaired: boolean;
  isUnpairing?: boolean;
  onPair: () => void;
  onUnpair: () => void;
  system: 'billit' | 'cashaca' | 'dexxter';
};

export const ExternalSystemCard = ({ disabled = false, imageUrl, isPaired, isUnpairing = false, onPair, onUnpair, system }: Props) => {
  const { t } = useTranslation(['common', 'settings']);

  const systemName = t(`settings:integrations.externalSystems.systems.${system}.name`);

  return (
    <Card.Root className={systemStyle} render={<li />}>
      <div className={headerStyle}>
        <img alt={systemName} className={logoStyle} src={imageUrl} />

        {isPaired && <StatusTag icon="Check" label={t('settings:integrations.externalSystems.paired')} status="success" />}
      </div>

      <div className={contentStyle}>
        <Title as="h3" styleAs="h4">
          {t('settings:integrations.externalSystems.pairWith', { system: systemName })}
        </Title>

        <Text>{t(`settings:integrations.externalSystems.systems.${system}.description`)}</Text>

        {system === 'dexxter' && <Text className={discountStyle}>{t('settings:integrations.externalSystems.systems.dexxter.tag')}</Text>}
      </div>

      <div className={actionsStyle}>
        {isPaired ? (
          <Button emphasis="secondary" loading={isUnpairing} onClick={onUnpair}>
            {t('settings:integrations.unpair')}
          </Button>
        ) : (
          <>
            <Button disabled={disabled} onClick={onPair}>
              {t('settings:integrations.pair')}
            </Button>

            {system === 'dexxter' && (
              <ExternalLinkButton emphasis="secondary" href="https://dexxter.be/creativeshelter">
                {t('settings:integrations.externalSystems.createAccount')}
              </ExternalLinkButton>
            )}
          </>
        )}
      </div>
    </Card.Root>
  );
};
